/**
 * Détection des rôles organisation (aligné mobile OrgListScreen + current_user_roles).
 */

export const normalizeRoleKey = (roleInput) => {
    if (!roleInput) return null;
    if (typeof roleInput === 'object') {
        const id = String(roleInput.id || '').toLowerCase();
        const name = String(roleInput.name || '').toLowerCase();
        if (id === 'cashier' || name === 'cashier' || name.includes('caissier')) return 'cashier';
        if (id === 'admin' || name === 'admin' || name.includes('administr')) return 'admin';
        return normalizeRoleKey(name || id);
    }
    const normalized = String(roleInput).toLowerCase().trim();
    if (normalized === 'both') return 'both';
    if (normalized.includes('caissier') || normalized === 'cashier') return 'cashier';
    if (normalized.includes('admin') || normalized === 'administrator' || normalized === 'admin') {
        return 'admin';
    }
    return normalized || null;
};

/** Rôles distincts (admin / cashier) pour une organisation. */
export const getOrganizationRoleKeys = (company) => {
    const roles = company?.current_user_roles || company?.roles || [];
    const keys = new Set();
    roles.forEach((r) => {
        const key = normalizeRoleKey(r);
        if (key === 'admin' || key === 'cashier') keys.add(key);
    });
    return Array.from(keys);
};

export const deriveOrganizationAccess = (company) => {
    const roles = company?.current_user_roles || company?.roles || [];
    const roleKeys = getOrganizationRoleKeys(company);

    let role = 'admin';
    if (roleKeys.length > 1) {
        role = 'both';
    } else if (roleKeys.length === 1) {
        role = roleKeys[0];
    } else if (roles.length === 1) {
        role = normalizeRoleKey(roles[0]) || 'admin';
    }

    return { role, roleKeys, roles };
};

export const normalizeCompany = (company) => {
    const { role, roles } = deriveOrganizationAccess(company);

    return {
        ...company,
        id: company.id,
        name: company.name,
        logo: company.logo || '🏢',
        category: company.category ?? company.category_id ?? 'other',
        role,
        roles,
        current_user_roles: roles,
        users: company.userCount ?? company.users ?? 1,
        createdAt: company.createdAt
            ? typeof company.createdAt === 'string' && !/^—$/.test(company.createdAt)
                ? company.createdAt
                : new Date(company.createdAt).toLocaleDateString('fr-FR')
            : '—',
        status: company.status ?? 'active',
    };
};

export const normalizeCompanies = (companies) => {
    const mapped = (companies || []).map(normalizeCompany);
    return mapped.reduce((acc, company) => {
        const existing = acc.find((c) => c.id === company.id);
        if (!existing) {
            acc.push(company);
            return acc;
        }
        const existingKeys = getOrganizationRoleKeys(existing).sort().join(',');
        const newKeys = getOrganizationRoleKeys(company).sort().join(',');
        if (existingKeys !== newKeys) {
            const index = acc.indexOf(existing);
            acc[index] = company;
        }
        return acc;
    }, []);
};

export const getRoleLabel = (roleKey) => {
    if (roleKey === 'cashier') return 'Caissier';
    if (roleKey === 'admin') return 'Administrateur';
    if (roleKey === 'both') return 'Admin & Caissier';
    return roleKey || 'Utilisateur';
};

export const organizationNeedsRoleChoice = (org) =>
    org?.role === 'both' || getOrganizationRoleKeys(org).length > 1;

export const resolveRoleFromApiRole = (apiRole) => normalizeRoleKey(apiRole);
